
namespace SorAraBul.Administration {

    @Serenity.Decorators.registerClass()
    export class CompaniesGrid extends Serenity.EntityGrid<CompaniesRow, any> {
        protected getColumnsKey() { return CompaniesColumns.columnsKey; }
        protected getDialogType() { return CompaniesDialog; }
        protected getIdProperty() { return CompaniesRow.idProperty; }
        protected getInsertPermission() { return CompaniesRow.insertPermission; }
        protected getLocalTextPrefix() { return CompaniesRow.localTextPrefix; }
        protected getService() { return CompaniesService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        protected getButtons() : Serenity.ToolButton[] {
            var buttons = super.getButtons();

            if (!Authorization.hasPermission("Administration:SuperAdmin"))
                buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);            

            return buttons;
        }
    }
}